import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import { Row, Col, Label, FormGroup, Button, FormText } from "reactstrap";
import logosm from "../../../../src/assets/images/logo-dark.webp";
import login_bg from "../../../../src/assets/images/memberportal.webp";
import { resetMemberPasswordRequest } from "../../../redux/frontend/auth/forgot/action";
import { connect } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import { useRef } from "react";
import { __t } from "../../../i18n/translator";
import { useEffect } from "react";
function ResetPasswordMember(props) {
  const { isApiSuccess, resetPassword } = props;
  const token = useParams();
  const validator = useRef(new SimpleReactValidator());
  const navigate = useNavigate();
  const initialValues = {
    newPassword: "",
    confirmPassword: "",
  };
  const handleSubmit = async (values) => {
    if (validator.current.allValid()) {
      let ResetVal = {
        token: token.token,
        newPassword: values.password,
        confirmPassword: values.confirmPassword,
      };
      resetPassword(ResetVal);
    } else {
      validator.current.showMessages();
    }
  };
  useEffect(() => {
    if (isApiSuccess === true) {
      navigate("/login");
    }
  }, [isApiSuccess !== false]);

  return (
    <div className="comtainer">
      <div className="login_box">
        <div className="login_bg_fornt">
          <img alt="login_bg" src={login_bg} />
        </div>
        <div className="login_field_fornt">
          <Row>
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
              {({ values }) => (
                <Col className="login-form">
                  <div className="loging-head">
                    <img alt="Logo" src={logosm} />
                    <h2>Reset Password</h2>
                  </div>
                  <Form className="form-horizontal form-login row">
                    <FormGroup className="col-12 sticky_label">
                      <Field
                        id="password"
                        name="password"
                        className="form-control"
                        type="password"
                        placeholder="Password must contain minimum 6 characters"
                        maxLength={99}
                        minLength={6}
                      />
                      <Label className="form-label" htmlFor="password">
                        Password <span className="text-danger required">*</span>
                      </Label>
                      {validator.current.message(
                        __t("validations.auth.password_required"),
                        values.password,
                        "required",
                        {
                          messages: {
                           required: __t("validations.auth.password"),
                          },
                        }
                      )}
                    </FormGroup>

                    <FormGroup className="col-12 sticky_label">
                      <Field
                        id="confirmPassword"
                        name="confirmPassword"
                        className="form-control"
                        type="password"
                        placeholder="Password must contain minimum 6 characters"
                        maxLength={99}
                        minLength={6}
                      />
                      <Label className="form-label" htmlFor="confirmPassword">
                        Confirm Password{" "}
                        <span className="text-danger required">*</span>
                      </Label>
                      {validator.current.message(
                        __t("validations.auth.confirm_password"),
                        values.confirmPassword,
                        "required",
                        {
                          messages: {
                            required: __t("validations.auth.confirm_password"),
                          },
                        }
                      )}
                      <FormText
                        style={{ fontSize: "0.75em", float: "inline-start" }}
                      >
                        Password must contain at least a minimum length of 6 characters.

                      </FormText>
                    </FormGroup>
                    <div className="d-flex flex-column justify-content-center align-items-center">
                      <Button
                        type="submit"
                        color="primary"
                        block
                        className="w-auto"
                        title="Send Link"
                      >
                        Submit
                      </Button>
                      <Link
                        to="/login"
                        className="pt-3 d-inline-block w-100 text-center"
                        title="back to login"
                      >
                        Back to login
                      </Link>
                    </div>
                  </Form>
                  <div className="policy-links">
                    <Link
                      to="https://www.hraga.com/terms-of-service"
                      target="_blank"
                      className="d-inline-block"
                      title="Terms of Service"
                    >
                      Terms of Service
                    </Link>
                    <Link
                      to="https://www.hraga.com/mbr-app-privacy-policy"
                      className="d-inline-block"
                      target="_blank"
                      title="Privacy Policy"
                    >
                      Privacy Policy
                    </Link>
                  </div>
                </Col>
              )}
            </Formik>
          </Row>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = ({ MemberForgot }) => {
  let isApiSuccess = false;
  if (MemberForgot?.resetPassword?.status) {
    isApiSuccess = MemberForgot.resetPassword.status;
  }
  return {
    isApiSuccess: isApiSuccess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetPassword: (data) => {
      dispatch(resetMemberPasswordRequest(data));
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordMember);
